import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const HeroSliderTwoSingle = ({ data }) => {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState("next"); // "next" | "prev"

  const total = data.length;

  const goTo = useCallback(
    (index, dir = "next") => {
      if (animating) return;
      setDirection(dir);
      setAnimating(true);
      setTimeout(() => {
        setCurrent(index);
        setAnimating(false);
      }, 400);
    },
    [animating],
  );

  const next = useCallback(() => {
    goTo((current + 1) % total, "next");
  }, [current, total, goTo]);

  const prev = useCallback(() => {
    goTo((current - 1 + total) % total, "prev");
  }, [current, total, goTo]);

  // Auto-advance every 5 seconds
  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const slide = data[current];

  return (
    <div className="slide d-flex align__center poss--relative hero-video-background">
      {/* ── Video Background ── */}
      <video autoPlay loop muted className="hero-video">
        <source
          src={process.env.PUBLIC_URL + "/videos/video_new.mp4"}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <div className="video-overlay" />

      {/* ── Slider CSS ── */}
      <style>{`
        .hs-content {
          transition: opacity 0.4s ease, transform 0.4s ease;
        }
        .hs-content.hs-out-next {
          opacity: 0;
          transform: translateY(-18px);
        }
        .hs-content.hs-out-prev {
          opacity: 0;
          transform: translateY(18px);
        }
        .hs-content.hs-in {
          opacity: 1;
          transform: translateY(0);
        }

        /* Prev / Next arrow buttons */
        .hs-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 0;
          width: 46px;
          height: 46px;
          border-radius: 50%;
          border: 1.5px solid rgba(255,255,255,0.25);
          background: rgba(255,255,255,0.06);
          backdrop-filter: blur(8px);
          color: #000000;
          font-size: 22px;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.25s, border-color 0.25s, transform 0.2s;
          outline: none;
        }
        .hs-arrow:hover {
          background: rgba(255,255,255,0.15);
          border-color: rgba(255,255,255,0.5);
          transform: translateY(-50%) scale(1.08);
        }
        .hs-arrow-left  { left: 24px; }
        .hs-arrow-right { right: 24px; }

        /* Dot indicators */
        .hs-dots {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: 28px;
        }
        .hs-dot {
          height: 8px;
          width: 8px;
          border-radius: 4px;
          background: rgba(255,255,255,0.25);
          border: none;
          cursor: pointer;
          padding: 0;
          transition: background 0.3s, width 0.3s;
        }
        .hs-dot.active {
          background: #fff;
          width: 24px;
        }

        /* Progress bar */
        .hs-progress {
          position: absolute;
          bottom: 0;
          left: 0;
          height: 3px;
          background: rgba(255,255,255,0.12);
          width: 100%;
          z-index: 10;
        }
        .hs-progress-fill {
          height: 100%;
          background: linear-gradient(90deg, rgba(255,255,255,0.5), rgba(255,255,255,0.9));
          animation: hsFill 5s linear forwards;
        }
        @keyframes hsFill {
          from { width: 0%; }
          to   { width: 100%; }
        }
      `}</style>

      {/* ── Arrow: Prev ── */}
      {/* <button
        className="hs-arrow hs-arrow-left"
        onClick={prev}
        aria-label="Previous slide"
      >
        ‹
      </button> */}

      {/* ── Main Content ── */}
      <div className="container poss--relative z-1">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-xl-7 col-md-12 col-sm-12 col-12 d-flex align-items-center">
            <div
              className={`slide__inner text-center hs-content ${
                animating
                  ? direction === "next"
                    ? "hs-out-next"
                    : "hs-out-prev"
                  : "hs-in"
              }`}
            >
              <h1>{slide.title}</h1>
              <p>{slide.text}</p>
            </div>
          </div>

          {/* Register button */}
          <div className="text-center w-100">
            <a
              className="slide__btn dg__btn"
              href="https://portal.thepips.com/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              Register now
            </a>
          </div>

          {/* Dot indicators */}
          <div className="w-100">
            <div className="hs-dots">
              {data.map((_, i) => (
                <button
                  key={i}
                  className={`hs-dot${i === current ? " active" : ""}`}
                  onClick={() => goTo(i, i > current ? "next" : "prev")}
                  aria-label={`Go to slide ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Arrow: Next ── */}
      {/* <button
        className="hs-arrow hs-arrow-right"
        onClick={next}
        aria-label="Next slide"
      >
        ›
      </button> */}

      {/* ── Progress bar ── */}
      <div className="hs-progress">
        <div className="hs-progress-fill" key={current} />
      </div>
    </div>
  );
};

HeroSliderTwoSingle.propTypes = {
  data: PropTypes.array.isRequired,
};

export default HeroSliderTwoSingle;
